<template>
  <div class="q-pa-md">
    <h1 class="text-h4 text-center">{{ weekday }}, {{ month }} {{ day }}</h1>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useFormatDate } from '../composables/formatDate'
import { useUserStore } from '../store/useUserStore'
import { storeToRefs } from 'pinia'
const props = withDefaults(
  defineProps<{
    date?: Date
  }>(),
  { date: undefined }
)
const store = storeToRefs(useUserStore())
const day = computed(() => useFormatDate(props.date, { language_choice: store.language }).day())
const weekday = computed(() =>
  useFormatDate(props.date, { language_choice: store.language }).weekday()
)
const month = computed(() => useFormatDate(props.date, { language_choice: store.language }).month())
</script>
